export default "__VITE_ASSET__wHyD7bdg__"